import { Grid, Typography, useTheme } from '@mui/material'
import React from 'react'
import { useStyles } from './style'
import { resolveContentType } from '../../util/content-type'

const ContentTypeIcon = ({ type = 'article', showDescription = false, secondaryType }) => {
  // Content carries whatever primaryType was stored, while the bundled catalogue
  // only knows the formats its package version shipped with. A format tagged by a
  // migration before this app is redeployed resolves to nothing here, and reading
  // `.types` off it used to throw - taking the whole content editor down, since
  // this renders inside the editor's information panel. Falling back to the raw
  // stored value keeps the panel readable, which is what the sibling select does.
  const { format, type: subType } = resolveContentType([type, secondaryType])

  const { palette } = useTheme()

  const classes = useStyles({
    color: palette.contentType[format?.name]
  })

  const formatLabel = format?.label ?? type

  return (
    <Grid container spacing={0} alignItems='flex-start' wrap='nowrap'>
      <Grid item className={classes.icon}>{format?.icon}</Grid>
      <Grid item className={classes.labelCtn} aria-label={`content type, ${formatLabel}`}>
        <Typography variant='body1' className={classes.label}>{subType?.label ?? formatLabel}</Typography>
        {subType ? <Typography variant='caption' className={classes.subType}>{formatLabel}</Typography> : <span>&nbsp;</span>}
        {showDescription && <Typography variant='body2' className={classes.description}>{format?.description}</Typography>}
      </Grid>
    </Grid>
  )
}

export default ContentTypeIcon
